import {
  Modal,
  ModalBody,
  ModalFoot,
  ModalHead,
  Text,
} from '@dixa/lib-shared-habla';
import { electron } from 'lib-shared-electron';

import { createAppModal } from 'utils/modal';

import styles from './desktopAppPwaNoticeModal.module.scss';

export const DesktopAppPwaNoticeModal = createAppModal(
  { type: 'app:desktopAppPwaNotice' },
  ({ isOpen, hide }): JSX.Element | null => {
    if (!electron.isElectron()) {
      return null;
    }

    return (
      <Modal isOpen={isOpen} onClose={hide} className={styles.modal}>
        <ModalHead
          title="The Dixa Desktop App is no longer supported"
          onClose={hide}
        />

        <ModalBody>
          <Text.Paragraph>
            Please switch to the new Dixa App (PWA) for the best experience. You
            may encounter issues if you continue using this app.{' '}
            <Text.ExternalLink
              href="https://support.dixa.help/en/articles/1808-dixa-progressive-web-app"
              target="_blank"
              rel="noreferrer"
            >
              Learn more
            </Text.ExternalLink>
          </Text.Paragraph>
        </ModalBody>

        <ModalFoot confirmOnClick={hide} confirmName="Confirm" />
      </Modal>
    );
  },
);
